export default __webpack_public_path__ + "static/media/coresanscr55it-webfont.1bd6251d.woff2";